import { Grid } from '@mui/material';
import React, { useState } from "react";
import styles from "./ItemTagSearch.module.scss"
import imageFile from "../../../assets/images/default_product.png";
import { convertHexRfidToBigInt } from "../../../helpers/stock/StockHelper"
import i18n from 'i18n';


const ItemTagSearch = ({product, tag}) => {

    const [imageError, setImageError] = useState(false);

    return (
        <Grid container className={styles["grid-content"]} sx={{height: {xs:'164px', sm:'164px', md:'100px'}}}>
            <Grid md={5} sm={12} xs={12} >
                <div className={styles["product-content"]}>
                    <img src={(!product?.image || imageError) ? imageFile : product.image}
                        onError={() => { setImageError(true) }} />
                    <div>
                        <div className={styles["product-name"]}>
                            {product ? product?.name : "Alarma sin producto"}
                        </div>
                        <div className={styles["product-sku"]}>
                            {i18n.t("sku")} {product && product?.sku}
                        </div>
                    </div>
                </div>
                <Grid container className={styles["font-data"]} sx={{marginTop:'10px', height: 'auto'}}>
                    <Grid xs={2} sm={1}  sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }} >
                        TAG
                    </Grid>
                    <Grid  sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }} >
                        {tag}
                    </Grid>
                </Grid>
                <Grid container className={styles["font-data"]}>
                    <Grid xs={2} sm={1} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }} >
                        EPC
                    </Grid>
                    <Grid sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }} >
                        {convertHexRfidToBigInt(tag)}
                    </Grid>
                </Grid>
            </Grid>
            <Grid md={4} sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }} >
                <div className={styles["font-data"]}>
                    <div>
                        TAG
                    </div>
                    <div >
                        {tag}
                    </div>
                </div>
            </Grid>
            <Grid md={3} sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}>
                <div className={styles["font-data"]}>
                    <div>
                        EPC
                    </div>
                    <div>
                        {convertHexRfidToBigInt(tag)}
                    </div>
                </div>
            </Grid>

        </Grid>
    )
}

export default ItemTagSearch;